cc.Class({
    extends: cc.Component,

    properties: {
        sprite: cc.Sprite
    },

    reuse () {
    },

    play () {
        cc.error('Need to extend and override the method!');
    }
});
